// DS: C41
import React, { useState } from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { useChildrenFolding } from '@wix/da-hooks/pkg/useChildrenFolding';
import TagList from '../TagList';
import Tag from '../Tag';
import s from './FoldableTagList.scss';
const MAX_LINES = 2;
const TAG_SPACING = parseInt(s['tag-spacing'], 10);
// TODO: this won't internationalize well
const TOGGLE_BUTTON_WIDTH = parseInt(s['more-button-width'], 10);
const TAG_KEY_FN = (tag)=>tag.name;
/** A TagList that includes a final, tag-like toggle button that
 *  folds or expands the list from 2 lines to as many as needed. */ export const FoldableTagList = ({ tags , className , isFoldable =true , moreLabel , lessLabel  })=>{
    const [isFolded, setIsFolded] = useState(isFoldable);
    const { sizedItems , hasHidden , containerRef  } = useChildrenFolding(tags, {
        maxLines: MAX_LINES,
        itemSpacing: TAG_SPACING,
        endPadding: TOGGLE_BUTTON_WIDTH,
        getItemKey: TAG_KEY_FN
    });
    const sizedTags = sizedItems.map(({ item , isOverflow  })=>({
            tagname: item.name,
            href: item.url,
            className: isFoldable && isFolded && isOverflow ? s['overflowed'] : undefined,
            biData: BiData({
                evid: 391,
                tag_text: item.name,
                link_url: item.url
            })
        }));
    return /*#__PURE__*/ React.createElement(TagList, {
        className: className,
        tags: sizedTags,
        size: "medium",
        isTruncated: true,
        multiline: true,
        ref: containerRef
    }, isFoldable && hasHidden && /*#__PURE__*/ React.createElement(Tag, {
        /* no collision bc hyphens aren't accepted in tag creation */ key: "more-or-less",
        className: s['more-or-less'],
        size: "medium",
        onClick: ()=>setIsFolded(!isFolded),
        biData: BiData({
            evid: 2,
            click_info: isFolded ? 'more' : 'less'
        })
    }, isFolded ? moreLabel : lessLabel));
};
FoldableTagList.displayName = 'FoldableTagList';
export default FoldableTagList;
